module.exports = __webpack_public_path__ + "static/media/image3.546db255.jpeg";